'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import { UNDERWRITER_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import useCorporateTopCompany from './useCorporateTopCompany';
import {
  ICorporateTopFilterPayload,
  ITopCompaniesCorporateResponse,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/interfaces';

type TopUnderwritersContextType = ReturnType<typeof useCorporateTopCompany>;

export const CorporateTopUnderwritersContext = createContext<TopUnderwritersContextType>(null);

export const useCorporateTopUnderwritersContext = () => {
  const context = useContext(CorporateTopUnderwritersContext);
  if (!context) {
    throw new Error('useCorporateTopUnderwritersContext must be used within the CorporateTopUnderwritersContext');
  }
  return context;
};

interface IProps {
  topParents?: ITopCompaniesCorporateResponse & { filters: ICorporateTopFilterPayload },
}

const CorporateTopUnderwritersContextProvider = ({ children, topParents }: PropsWithChildren<IProps>) => (
  <CorporateTopUnderwritersContext.Provider value={ useCorporateTopCompany({
    serverData: topParents,
    companyRole: UNDERWRITER_NAME,
  }) }
  >
    { children }
  </CorporateTopUnderwritersContext.Provider>
);

export default CorporateTopUnderwritersContextProvider;
